import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PagDoubleChevronRight = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6707 21.01C11.3826 20.7219 11.2208 20.331 11.2208 19.9235C11.2208 19.516 11.3826 19.1252 11.6707 18.837L18.2681 12.2396L11.6707 5.64218C11.5239 5.50042 11.4068 5.33084 11.3263 5.14335C11.2458 4.95585 11.2034 4.75419 11.2016 4.55014C11.1998 4.34609 11.2387 4.14372 11.316 3.95486C11.3932 3.76599 11.5074 3.59441 11.6517 3.45011C11.7959 3.30582 11.9675 3.19171 12.1564 3.11444C12.3453 3.03717 12.5476 2.99828 12.7517 3.00006C12.9557 3.00183 13.1574 3.04423 13.3449 3.12477C13.5324 3.20531 13.702 3.32238 13.8437 3.46916L21.5277 11.1531C21.8158 11.4413 21.9776 11.8321 21.9776 12.2396C21.9776 12.6471 21.8158 13.0379 21.5277 13.3261L13.8437 21.01C13.5555 21.2982 13.1647 21.46 12.7572 21.46C12.3497 21.46 11.9589 21.2982 11.6707 21.01Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.44995 21.01C2.16185 20.7218 2 20.331 2 19.9235C2 19.516 2.16185 19.1252 2.44995 18.837L9.04738 12.2396L2.44995 5.64216C2.17001 5.35232 2.01511 4.96412 2.01861 4.56118C2.02212 4.15824 2.18374 3.7728 2.46867 3.48787C2.7536 3.20293 3.13905 3.04131 3.54199 3.03781C3.94493 3.03431 4.33313 3.18921 4.62297 3.46915L12.3069 11.1531C12.595 11.4413 12.7569 11.8321 12.7569 12.2396C12.7569 12.6471 12.595 13.0379 12.3069 13.3261L4.62297 21.01C4.33478 21.2981 3.94396 21.46 3.53646 21.46C3.12896 21.46 2.73814 21.2981 2.44995 21.01Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PagDoubleChevronRight.displayName = 'PagDoubleChevronRight';
